import { Modal, Radio, message, Select } from "antd";
import styles from "./index.module.scss";
import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { initializeResource } from "@/apis/discover";
import intl from "react-intl-universal";
let typeList = [];
let suffixList = [];
const CreateResource = ({ setModalOpen, modalOpen }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [firstType, setFirstType] = useState("OpenData");
  const [secondType, setSecondType] = useState("");
  const [liceseType, setLiceseType] = useState("0");
  const [typeTitle, setTypeTitle] = useState("");
  const [resourceType, setResourceType] = useState("");
  const [isShow_api, setIsShow_api] = useState(false);
  const navigate = useNavigate();
  // 获取类型列表和后缀列表
  useEffect(() => {
    let data = localStorage.getItem("jsonTypeData");
    if (data) {
      let res = JSON.parse(data);
      typeList = res.typeList;
      suffixList = res.suffixList;
    }
  }, []);
  // 选择一级标题
  const changeFirstType = (e) => {
    setFirstType(e.target.value);
    setSecondType("");
    setResourceType("");
    setTypeTitle("");
  };

  // 选择二级标题
  const changeSecondType = (e) => {
    setSecondType(e.target.value);
    setResourceType("")
  };
  // 获取二级单选框
  const secondList = useMemo(() => {
    if (typeList) {
      return (
        typeList.filter((item) => item.value === firstType)[0]?.children || []
      );
    }
  }, [firstType, modalOpen]);
  // 根据secondType 获取类型下拉菜单
  const selectOption = useMemo(() => {
    // 证书类型
    if (secondType === "OpenCodes") {
      setLiceseType("1");
    } else {
      setLiceseType("0");
    }
    if (secondType) {
      const arr1 =
        typeList.filter((item) => item.value === firstType)[0]?.children || [];
      const arr2 = arr1.filter((item) => item.value === secondType);
      if (arr2.length > 0) {
        const title = arr2[0].title;
        const str = title.replace(/\s/g, "_");
        setTypeTitle(title);
        setIsShow_api(arr2[0].isShow_api);
        return suffixList[str];
      } else {
        setIsShow_api(false);
        return [];
      }
    } else {
      setIsShow_api(false);
      return [];
    }
  }, [secondType]);
  // 跳转到个人中心
  const toLink = (url) => {
    navigate(url);
    window.scrollTo(0, 0);
  };
  const handleModalOk = () => {
    if (!secondType) {
      message.warning(
        `${intl.get("Please select the")} ${intl.get("Resource Type")}！`
      );
      return;
    }

    if (!resourceType) {
      message.warning(
        `${intl.get("Please select the")} ${intl.get(typeTitle)}！`
      );
      return;
    }

    setConfirmLoading(true);
    initializeResource({
      secondType: secondType,
      resourceType: resourceType,
    }).then((res) => {
      message.success(intl.get("Created successfully"));
      setConfirmLoading(false);
      toLink(
        `/discover/share?id=${res.data.resourceUuid}&firstType=${firstType}&secondType=${secondType}&resourceType=${resourceType}&typeTitle=${typeTitle}&liceseType=${liceseType}&isShow_api=${isShow_api}`
      );
      handleModalCancel();
    });
  };
  const handleModalCancel = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      title={intl.get("Resource Type")}
      open={modalOpen}
      onOk={handleModalOk}
      onCancel={handleModalCancel}
      destroyOnHidden
      maskClosable={false}
      zIndex={1222}
      confirmLoading={confirmLoading}
    >
      <Radio.Group
        block
        optionType="button"
        buttonStyle="solid"
        onChange={changeFirstType}
        value={firstType}
      >
        {typeList.map((item) => (
          <Radio key={item.value} value={item.value}>
            {intl.get(`Header.${item.label}`)}
          </Radio>
        ))}
      </Radio.Group>
      <Radio.Group onChange={changeSecondType} value={secondType}>
        {secondList.map((item) => (
          <Radio
            style={{ margin: "20px 10px 0px 0" }}
            key={item.value}
            value={item.value}
          >
            {intl.get(`Header.${item.label}`)}
          </Radio>
        ))}
      </Radio.Group>
      {typeTitle && (
        <React.Fragment>
          <h4 className={styles.h4Box}>
            {intl.get(typeTitle)}
            <span>*</span>
          </h4>
          <Select
            size="large"
            style={{ width: "100%", marginBottom: "20px" }}
            value={resourceType}
            onChange={(e) => {
              setResourceType(e);
            }}
            options={selectOption}
          />
        </React.Fragment>
      )}
    </Modal>
  );
};

export default CreateResource;
